import React from 'react'
import { IoArrowBackOutline } from 'react-icons/io5'

function ViewExperiance({ viewExp, setViewExp, data }) {
    function getTimeGapInMonthsOrYears(startDate, endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const yearsDiff = end.getFullYear() - start.getFullYear();
        const monthsDiff = end.getMonth() - start.getMonth();
        let totalMonths = yearsDiff * 12 + monthsDiff + 1;
        if (totalMonths < 12) {
            return `${totalMonths} month${totalMonths !== 1 ? "s" : ""}`;
        }
        let years = Math.floor(totalMonths / 12);
        let remainingMonths = totalMonths % 12;    
        if (remainingMonths > 0) {
            return `${years}.${remainingMonths} years`;
        }

        return `${years} years`;
    }
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    console.log("gfsofsdfuufsi", formattedDate)
    return (
        <div>
            <div style={{ boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)" }}>
                <div style={{ paddingRight: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'white' }}>
                    <div className="common_table_header"><span onClick={() => setViewExp(false)} style={{ cursor: 'pointer' }}><IoArrowBackOutline size={25} /></span> Experience Details</div>
                </div>
                <div className="line_divide"></div>
                <div style={{ padding: 20, backgroundColor: 'white', }}>
                    <table style={{}}>
                        <tbody style={{ display: 'grid', gridTemplateColumns: true ? 'repeat(auto-fit, minmax(550px, 1fr))' : 'repeat(auto-fit, minmax(250px, 1fr))', gap: 10, wordBreak: 'break-word' }}>
                            {[
                                { label: "Work Experience Id", value: data.workExperienceId },
                                { label: "Company Name", value: data.companyName },
                                { label: "Start Date", value: data.startDate },
                                { label: "End Date", value: data.isCurrentlyWorking ? "Currently Working" : data.endDate },
                                { label: "Role", value: data.role },
                                { label: "Duration", value: getTimeGapInMonthsOrYears(data?.startDate, data?.endDate ? data.endDate : formattedDate) }
                            ].map((item, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: 20
                                    }}
                                >
                                    <th
                                        style={{
                                            fontWeight: 500,
                                            color: 'rgba(1, 41, 112, 0.6)',

                                            wordBreak: 'break-word',
                                            fontSize: true ? '15px' : '12px'
                                        }}
                                    >
                                        {item.label}
                                    </th>
                                    <td
                                        style={{
                                            fontWeight: 300,
                                            wordBreak: 'break-word',
                                            fontSize: true ? '15px' : '12px'
                                        }}
                                    >
                                        {item.value}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>
            </div>
        </div >
    )
}

export default ViewExperiance
